import CheckLine from './checkLine.js';
import Period from './period.js';

class Student{
    name = null;
    firstName = null;
    lastName = null;
    vat = null;
    date = null;
    local = null;
    school = null;
    schoolCourse = null;
    lastYear = null;
    imageRightsWhatsapp = null;
    imageRightsPromotion = null;
    imageRightsSocialMedia = null;
    leaveAlone = null;

    // Periodos
    periods = [];
    selectedPeriods = [];

    //Ficheros
    catsalut = null;
    vaccinationBook = null;

    // Salud
    allergies = null;
    allergiesDescription = null;
    typeDisease = null;
    typeDiseaseDescription = null;
    vaccinated = null;
    medicalObservations = null;
    relatives = [];
    local = null;

    //To orders
    variations = [];
    reservations = [];
    discount = null;
    avaliableDiscounts = null;
    total = 0;
    subtotal = 0;
    fixedCosts = [];
    reservationSubtotal = 0;

    constructor(discounts){
        this.avaliableDiscounts = discounts;
        this.local = 0;
    }

    addRelative() {
        this.relatives.push({
            relativeName: null,
            relativeType: null
        });
    }

    removeRelative(relative) {
        if (this.relatives.indexOf(relative) >= 0) {
            this.relatives.splice(this.relatives.indexOf(relative), 1);
        }
    }

    setPeriods(periods) {
        this.periods = periods;
        this.selectedPeriods = [];
    }

    setVariations(variations) {
        this.fixedCosts = [];
        this.variations = variations;
        
        for(let variation of variations){
            this.fixedCosts = this.fixedCosts.concat(variation.fixedCosts);
        }

        this.fixedCosts = this.fixedCosts.unique("ID");
    }

    setReservations(reservations) {
        this.reservations = reservations;
    }

    getCategoriesPeriods(){
        return this.periods.map(p => p.category).unique("name"); 
    }

    getPeriodsFromCategory(categoryName){
        let periods = this.periods.filter(p => p.category.name == categoryName);
        let titles = {};

        for(let i = 0; i < periods.length; i++){
            let period = periods[i];
            
            if(!titles[period.title]){
                titles[period.title] = new Period(period.id, period.title, period.start, period.end, period.product, period.category, period.course, period.stock, period.reservations);
            }
            else{
                titles[period.title].stock += period.stock;
            }
        }

        return Object.values(titles);
    }

    checkDateAndCourse(courses){
        if(this.date && this.schoolCourse){
            let date = Date.parse(this.date); 
            let year = date.getFullYear();
            let currentYear = (new Date(Date.now())).getFullYear();
            let age = currentYear - year;
            // let element = (age - 2); //Debido a la diferencia entre el primer elemento que es a las 3 años de edad 2023
            let element = (age - 3); //Debido a la diferencia entre el primer elemento que es a las 3 años de edad 2024
            let index = element - 1;
            
            if (!courses[index] || this.schoolCourse !== courses[index].value){
                window.alert("El curs seleccionat no coincideix amb l'edat de l'alumne");
            }
        }
    }

    groupReservations(){
        let periods = [];

        for(let reservation of this.reservations){
            for(let period of reservation.periods){
                if(!periods.includes(period.id)){
                    periods.push(period.id);
                }
            }
        }

        return periods;
    }

    data(){
        return {
          name: this.name,
          firstName: this.firstName,
          lastName: this.lastName,
          vat: this.vat,
          date: this.date,
          local: this.local,
          school: this.school,
          schoolCourse: this.schoolCourse,
          lastYear: this.lastYear,
          imageRightsWhatsapp: this.imageRightsWhatsapp,
          imageRightsPromotion: this.imageRightsPromotion,
          imageRightsSocialMedia: this.imageRightsSocialMedia,
          leaveAlone: this.leaveAlone,
          allergies: this.allergies,
          allergiesDescription: this.allergiesDescription,
          typeDisease: this.typeDisease,
          typeDiseaseDescription: this.typeDiseaseDescription,
          vaccinated: this.vaccinated,
          medicalObservations: this.medicalObservations,
          catsalut: this.catsalut,
          vaccinationBook: this.vaccinationBook,
          relatives: this.relatives.filter(
            (r) => r.relativeName && r.relativeType
          ),
          discount: this.discount && this.discount.id,
          total: this.total,
          subtotal: this.subtotal,
          diff: this.calculateDiff(),
          reservationSubtotal: this.reservationSubtotal,
          fixedCosts: this.fixedCosts.map((fc) => fc.ID),
          variations: this.variations.map((v) => {
            return {
              id: v.wooVariation.variation_id,
              periods: v.periods.map((p) => p.id),
            }
          }),
          reservations: this.reservations.map((v) => {
            return {
              id: v.wooVariation.variation_id,
              periods: v.periods.map((p) => p.id),
            }
          }),
        }
    }

    //Subtotal
    calculateSubtotal(){
        this.subtotal = 0;

        for(let variation of this.variations){
            let wooVariation = variation.wooVariation;
            if(wooVariation){
                this.subtotal += parseFloat(wooVariation.display_price);
            }
        }

        return this.subtotal;
    }

    calculateReservationSubtotal(){
        this.reservationSubtotal = 0;

        for(let reservation of this.reservations){
            let wooVariation = reservation.wooVariation;
            if(wooVariation){
                this.reservationSubtotal += parseFloat(wooVariation.display_price);
            }
        }

        return this.reservationSubtotal;
    }

    //Diff
    calculateDiff() {
        return (this.subtotal - this.total).toFixed(2);
    }

    //Total
    calculateTotal(){
        this.total = 0;

        let applyDiscount = 0;

        for (let variation of this.variations) {
            let wooVariation = variation.wooVariation;

            if (wooVariation) {
                let price = parseFloat(wooVariation.display_price);
                let fixedCosts = 0;

                if(variation.fixedCosts && variation.fixedCosts.length){
                    for(let fixedCost of variation.fixedCosts){
                        fixedCosts += parseFloat(fixedCost.price);
                    }

                    price -= fixedCosts;
                    this.total += fixedCosts;
                }

                if (variation.schedule == CheckLine.scheduleValues.meal) {
                    // this.total += price;
                    applyDiscount += price;
                }
                else {
                    applyDiscount += price;
                }
            }
            else{
                console.log("ERROR -->", this, variation);
            }
        }

        if (applyDiscount > 0) {
            if(this.discount){
                this.total += applyDiscount - (applyDiscount * parseFloat(this.discount.discount) / 100);
            }
            else{
                this.total += applyDiscount;
            }
        }

        return this.total;
    }

    //Discount
    calculateDiscount(numStudents, fullDeposit) {
        let now = Date.now();
        let local = this.local;
        let lastYear = this.lastYear;

        this.discount = this.avaliableDiscounts.find(discount => {
            let coincident = true;
            
            for (let criteria in discount.criteria) {
                switch (criteria) {
                    case "deposit":
                        if (discount.criteria[criteria] !== null && discount.criteria[criteria] !== '') {
                            if (discount.criteria[criteria] === "1" || discount.criteria[criteria] === "0") {
                                coincident = parseInt(discount.criteria[criteria]) == fullDeposit;
                            }
                            else {
                                let date = Date.parse(`${discount.criteria[criteria]} 23:59:59`);
                                coincident = now <= date && fullDeposit;
                            }
                        }

                        break;
                    
                    case "local":
                        if (discount.criteria[criteria] !== null && discount.criteria[criteria] !== '') {
                            coincident = parseInt(discount.criteria[criteria]) == (local || lastYear);
                        }

                        break;

                    case "num_students":
                        if (discount.criteria[criteria] !== null && discount.criteria[criteria] !== '') {
                            coincident = discount.criteria[criteria] == numStudents;
                        }

                        break;
                    case "greater_or_equal_num_students":
                        if (discount.criteria[criteria] !== null && discount.criteria[criteria] !== '') {
                            coincident = parseInt(discount.criteria[criteria]) <= numStudents;
                        }

                        break;
                    case "inscription":
                        if (discount.criteria[criteria] !== null && discount.criteria[criteria] !== '') {
                            let date = Date.parse(`${discount.criteria[criteria]} 23:59:59`);
                            coincident = now <= date;
                        }

                        break;
                    case "not_product":
                        if (discount.criteria[criteria] !== null && discount.criteria[criteria] !== '') {
                            coincident = !this.variations.find(variation => variation.product.id == discount.criteria[criteria]);
                        }

                        break;
                }

                if (!coincident) {
                    break;
                }
            }

            return coincident;
        });

        return this.discount;
    }
}

export default Student;